/**
 *  parse query string
 *  ?foo=bar returns {'foo': 'bar'}
 *  foo=bar returns {'foo': 'bar'}
 */
export function parseQuery(queryString) {
    const query = {};
    const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
}
export function stringParamToBoolean(input) {
    return input === 'false' || input === '0' || input === 'no'
        ? false
        : Boolean(input);
}
